<template>
<div class="chapter">
<div class="inner_page">
<div id="dearreader">
<p class="noindent">Dear Reader,<br/><br/></p>
<p class="noindent">This holiday season, we’ve selected books that are sure to warm your heart—all with heroes who redefine the phrase “the gift of giving.” Since 1992, Margaret Moore has written seventeen full-length historicals for Harlequin and two short stories, and will soon publish her first historical for Avon Books, <i>A Scoundrel’s Kiss.</i> Look for it around Valentine’s Day. Critics have described her as “a master storyteller,” and “a genius of the genre.” In <i>A Warrior’s Passion</i>, the ninth book in her medieval WARRIOR SERIES, a young woman is forced into an unwanted betrothal before the man she truly loves—and whose child she carries—can claim her as his wife. Don’t miss this exciting story!<br/><br/></p>
<p class="noindent">Linda Castle returns with the long-awaited sequel to <i>Fearless Hearts, Territorial Bride,</i> in which a cowgirl and an Eastern rogue must put their love to the test when she is thrown from a horse and seriously injured. <i>The Shielded Heart</i> by rising talent Sharon Schulze is the gripping tale of a warrior who learns to accept his special psychic gift as he teaches an enamel artisan about life and love.<br/><br/></p>
<p class="noindent">Rounding out the month is <i>Harrigan’s Bride</i> by award-winning author Cheryl Reavis, who also writes contemporary romances for Silhouette. Here, Thomas Harrigan returns from the Civil War to marry the bedridden, abandoned daughter of his late godmother. It’s great!<br/><br/></p>
<p class="noindent">Whatever your tastes in reading, you’ll be sure to find a romantic journey back to the past between the covers of a Harlequin Historical® novel.<br/><br/></p>
<p class="noindent">Sincerely,<br/><br/></p>
<p class="noindent">Tracy Farrell</p>
<p class="noindent">Senior Editor</p>
<div class="extract" id="extract1">
<p class="noindent">Please address questions and book requests to:</p>
<p class="noindent">Harlequin Reader Service</p>
<p class="noindent">U.S.: 3010 Walden Ave., P.O. Box 1325, Buffalo, NY 14269</p>
<p class="noindent">Canadian: P.O. Box 609, Fort Erie, Ont. L2A 5X3</p>
</div>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-dearreader.vue?4c755749